import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import Cloud from "../../assets/cloud.jpg";
import navod1 from "../../assets/navod1.PNG";
import navod2 from "../../assets/navod2.PNG";

const BRAND_DEEP = '#2c4767';
const BRAND_GOLD = '#b08d57';
const CREAM = '#f7f4ee';
const INK = '#1a2733';

const useStyles = makeStyles((theme) => ({
    wrap: {
        minHeight: '100vh',
        background: CREAM,
    },
    hero: {
        position: 'relative',
        backgroundImage: `linear-gradient(135deg, rgba(30, 53, 83, 0.72) 0%, rgba(44, 71, 103, 0.55) 100%), url(${Cloud})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: '#ffffff',
        padding: theme.spacing(10, 3, 6, 3),
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(14, 6, 8, 6),
        },
    },
    heroInner: {
        maxWidth: 880,
        margin: '0 auto',
    },
    heroEyebrow: {
        textTransform: 'uppercase',
        letterSpacing: 4,
        fontSize: 12,
        fontWeight: 600,
        opacity: 0.9,
        marginBottom: theme.spacing(2),
        color: '#e8d9b8',
    },
    heroTitle: {
        fontWeight: 700,
        fontSize: '2.2rem',
        lineHeight: 1.15,
        letterSpacing: '-0.5px',
        [theme.breakpoints.up('md')]: {
            fontSize: '2.6rem',
        },
    },
    heroDivider: {
        width: 56,
        height: 3,
        background: BRAND_GOLD,
        borderRadius: 2,
        margin: theme.spacing(3, 0, 0, 0),
    },
    contentWrap: {
        padding: theme.spacing(5, 3),
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(6, 6),
        },
    },
    contentCard: {
        background: '#ffffff',
        padding: theme.spacing(4),
        border: `1px solid rgba(176, 141, 87, 0.18)`,
        borderRadius: 14,
        boxShadow: '0 6px 22px rgba(44, 71, 103, 0.06)',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 3,
            background: `linear-gradient(90deg, ${BRAND_DEEP} 0%, ${BRAND_GOLD} 100%)`,
            borderTopLeftRadius: 14,
            borderTopRightRadius: 14,
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2.5),
        },
    },
    intro: {
        color: INK,
        fontSize: '1rem',
        lineHeight: 1.7,
        marginBottom: theme.spacing(3),
    },
    link: {
        color: BRAND_DEEP,
        fontWeight: 600,
        textDecoration: 'underline',
        textUnderlineOffset: 3,
        marginLeft: 6,
    },
    figure: {
        margin: theme.spacing(2, 0),
        padding: theme.spacing(2),
        background: '#fbfaf7',
        borderRadius: 10,
        border: `1px solid rgba(176, 141, 87, 0.18)`,
        textAlign: 'center',
    },
    image: {
        maxWidth: '100%',
        height: 'auto',
        borderRadius: 8,
        display: 'block',
        margin: '0 auto',
    },
}));

export default function GuideExcel() {
    const classes = useStyles();

    return (
        <div className={classes.wrap}>
            <CssBaseline/>

            <div className={classes.hero}>
                <div className={classes.heroInner}>
                    <Typography className={classes.heroEyebrow}>Návod</Typography>
                    <Typography variant="h1" component="h1" className={classes.heroTitle}>
                        Otvorenie exportu v Google Sheets
                    </Typography>
                    <div className={classes.heroDivider}/>
                </div>
            </div>

            <Container maxWidth="md" className={classes.contentWrap}>
                <div className={classes.contentCard}>
                    <Typography component="p" className={classes.intro}>
                        Prejdite na stránku Google Sheets:
                        <a className={classes.link} href="https://sheets.new" target="_blank" rel="noreferrer">
                            https://sheets.new
                        </a>
                        <br/>
                        (pre nahranie dokumentu musíte mať aktívny Google účet)
                    </Typography>
                    <div className={classes.figure}>
                        <img className={classes.image} src={navod1} alt="Krok 1 — otvorenie Google Sheets" loading="lazy"/>
                    </div>
                    <div className={classes.figure}>
                        <img className={classes.image} src={navod2} alt="Krok 2 — import súboru" loading="lazy"/>
                    </div>
                </div>
            </Container>
        </div>
    );
}
